import { Link as RouterLink, useNavigate } from "react-router";
import { Chip, Grid, styled } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { brand, Button, Link, Typography } from "@platform/design-system";

import { ROUTE_NAMES } from "../../../constants";

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: brand("supporting")(theme),
  color: theme.palette.common.white,
}));

const Header = ({ state }) => {
  const {
    data: { rfp, clientId },
    rfpCreationDate,
  } = state;
  const {
    details: { clientInfo },
  } = rfp;

  const navigate = useNavigate();
  const isProspect = clientInfo?.type === "prospect";

  const renderClientName = () => {
    if (isProspect) {
      return (
        <>
          <span>{clientInfo?.name}</span> <StyledChip label="Prospect" />
        </>
      );
    }
    if (clientId) {
      return (
        <Link
          component={RouterLink}
          to={`/${ROUTE_NAMES.CLIENTS}/${clientId}`}
          color="inherit"
          underline="hover"
        >
          {clientInfo?.name}
        </Link>
      );
    }
    return <span>{clientInfo?.name}</span>;
  };

  return (
    <>
      <Grid size={12} mt={15}>
        <Button
          onClick={() => navigate(`/${ROUTE_NAMES.RFPS}`)}
          startIcon={<ArrowBackIcon />}
          variant="tertiary"
        >
          Back
        </Button>
      </Grid>
      <Grid container mt={2} direction="row" mb={6}>
        <Grid size={12} display="flex">
          <Typography variant="display-medium">
            RFP {rfp.id} for {renderClientName()}
          </Typography>
        </Grid>
        {rfpCreationDate && (
          <Grid size={12} mt={1}>
            <Typography>
              Created on{" "}
              <Typography variant="body-large">
                <strong>{rfpCreationDate}</strong>
              </Typography>
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Header;
